module.exports = __webpack_public_path__ + "static/logo-chitf-4e57d1f3d5dbf679e0eee8beea9bd430.png";